import { useEffect, useState } from "react";
import { format, parseISO } from "date-fns";
import { toast } from "sonner";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { staffApi, errMsg } from "@/lib/api";
import { ACTIONS } from "@/lib/actions";

export const RequestLog = () => {
  const [rows, setRows] = useState([]);
  useEffect(() => { staffApi().get("/requests").then((r) => setRows(r.data)).catch((e) => toast.error(errMsg(e))); }, []);

  const setStatus = async (r, status) => {
    try { const res = await staffApi().patch(`/requests/${r.id}`, { status }); setRows(rows.map((x) => (x.id === r.id ? { ...x, status } : x))); toast.success(res.data.emailed ? "Approved — confirmation email sent" : "Status updated"); }
    catch (e) { toast.error(errMsg(e)); }
  };

  return (
    <div className="space-y-4" data-testid="request-log">
      <div>
        <h2 className="text-2xl font-bold tracking-tight text-slate-900">Requests</h2>
        <p className="text-sm text-slate-500">Visits, Victory Groups, discipleship, serving and pastoral care requests from the website.</p>
      </div>
      <div className="overflow-x-auto rounded-3xl border border-slate-200 bg-white">
        <Table>
          <TableHeader><TableRow><TableHead>Date</TableHead><TableHead>Request</TableHead><TableHead>Name</TableHead><TableHead>Contact</TableHead><TableHead>Details</TableHead><TableHead>Status</TableHead></TableRow></TableHeader>
          <TableBody>
            {rows.length === 0 && <TableRow><TableCell colSpan={6} className="py-10 text-center text-slate-400">No requests yet.</TableCell></TableRow>}
            {rows.map((r) => (
              <TableRow key={r.id} data-testid={`request-row-${r.id}`}>
                <TableCell className="whitespace-nowrap text-xs text-slate-500">{format(parseISO(r.created_at), "MMM d, h:mm a")}</TableCell>
                <TableCell className="whitespace-nowrap font-medium text-[#0A3A6B]">{ACTIONS[r.action]?.title}</TableCell>
                <TableCell className="font-medium">{r.name}</TableCell>
                <TableCell className="whitespace-nowrap text-xs">{r.phone}<br />{r.email}</TableCell>
                <TableCell className="max-w-[280px] text-xs text-slate-600">
                  {Object.entries(r.details || {}).map(([k, v]) => <span key={k} className="block"><b className="capitalize">{k.replace(/_/g, " ")}:</b> {v}</span>)}
                  {r.message && <span className="mt-1 block italic">{r.message}</span>}
                </TableCell>
                <TableCell>
                  <Select value={r.status} onValueChange={(v) => setStatus(r, v)}>
                    <SelectTrigger className="h-8 w-[120px]" data-testid={`request-status-${r.id}`}><SelectValue /></SelectTrigger>
                    <SelectContent className="bg-white"><SelectItem value="new">New</SelectItem><SelectItem value="contacted">Contacted</SelectItem><SelectItem value="done">Done</SelectItem></SelectContent>
                  </Select>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
};
